import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47b06982"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["src"]

import { ref, computed } from "vue";

import AppCheckbox from "@/components/atoms/input/AppCheckbox.vue";
import AppButton from "@/components/atoms/button/AppButton.vue";
import AppButtonOutline from "@/components/atoms/button/AppButtonOutline.vue";
import { authStore } from "@/store/auth";


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationConfirmation',
  props: {
  workerLastName: {
    type: String,
    required: true
  }
},
  emits: ["back", "confirm"],
  setup(__props, { emit }) {

const props = __props;


const isChecked = ref(false);


const applicationNotesImage = computed(() =>
  require("@/assets/img/applicationReminder/ApplicationNotes" +
    authStore.productAssetSuffix +
    ".png")
);

const onSubmit = () => {
  emit("confirm");
};

const onBack = () => {
  emit("back");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: applicationNotesImage.value,
      alt: "キャンセル方法",
      class: "image"
    }, null, 8, _hoisted_2),
    _createTextVNode(),
    _createElementVNode("p", null, "\n      現場の職員・ご利用者様・患者様が" + _toDisplayString(props.workerLastName) + "さんのことを待っています✨よろしくお願いします❗\n    ", 1),
    _createTextVNode(),
    _createVNode(AppCheckbox, {
      text: "確認しました",
      class: "checkbox",
      modelValue: isChecked.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isChecked).value = $event))
    }, null, 8, ["modelValue"]),
    _createTextVNode(),
    _createVNode(AppButton, {
      variant: "primary",
      class: "w-100",
      disabled: !isChecked.value,
      onClick: onSubmit
    }, {
      default: _withCtx(() => [
        _createTextVNode("勤務確定")
      ], undefined, true),
      _: 1
    }, 8, ["disabled"]),
    _createTextVNode(),
    _createVNode(AppButtonOutline, {
      onClick: onBack,
      variant: "primary",
      class: "w-100"
    }, {
      default: _withCtx(() => [
        _createTextVNode("戻る")
      ], undefined, true),
      _: 1
    })
  ]))
}
}

})